'use client'

import {ArticlesListContent, NewsListContent} from '../types'
import {PaginationProps} from 'antd'
import {observer} from 'mobx-react'
import {usePathname, useSearchParams} from 'next/navigation'

import {useRouter} from 'nextjs-toploader/app'
import qs from 'qs'
import {useEffect, useState} from 'react'

import {useStore} from '@/src/shared/hooks/useStore'
import {Pagination} from '@/src/shared/ui/pagination'

import * as UI from './pagination.styled'

export const NewsPagination = observer((props: PaginationProps) => {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const router = useRouter()
  const {pageData} = useStore<NewsListContent | ArticlesListContent>()
  let total = 0

  const [limit] = useState(() => {
    if ('articles' in pageData!.content) {
      return pageData!.content.articles.limit
    } else {
      return pageData!.content.news_list.limit
    }
  })

  const [page, setPage] = useState(() => {
    if ('articles' in pageData!.content) {
      return pageData!.content.articles.page
    } else {
      return pageData!.content.news_list.page
    }
  })

  if ('articles' in pageData!.content) {
    total = pageData!.content.articles.total
  } else {
    total = pageData!.content.news_list.total
  }

  useEffect(() => {
    let page = 1

    if ('articles' in pageData!.content) {
      page = pageData!.content.articles.page
    } else {
      page = pageData!.content.news_list.page
    }

    setPage(page)
  }, [pageData!.content])

  const onChangePage = (page: number) => {
    const currentSearchParams = qs.parse(searchParams.toString()) as Record<any, any>
    const queryParams = {...currentSearchParams}

    queryParams.page = page

    const queryParamsText = qs.stringify(queryParams)

    setPage(page)

    if (queryParamsText === qs.stringify(currentSearchParams)) return
    router.push(`${pathname}${queryParamsText && `?${queryParamsText}`}`)
  }

  return (
    <UI.Pagination as={Pagination} {...props} current={page} total={total} pageSize={limit} onChange={onChangePage} />
  )
})
